import { BBModel } from '../../bb_model';
import { Set } from './set';
import { EventChainCollection } from '../event_chain_collection';

class EventChainSet extends Set {

    constructor(company) {
        super(BBModel.Admin.EventChain, company);
    }

    getEventChain(company, id, params = {}) {
        params.id = id;
        return company.$get('event_chains', params)
            .then((event_chain) => {
                const url = event_chain.$link('self').href;
                if (this.set[url]) {
                    return this.set[url];
                } else {
                    const model = new BBModel.Admin.EventChain(event_chain);
                    this.addItem(model);
                    return model;
                }
            });
    }


    $query(company, params) {
        return EventChainCollection.$query(this, company, params);
    }
}

EventChainSet.group = 'event_chains';
EventChainSet.model = 'event_chain';
EventChainSet.all = {};

export {
    EventChainSet
};
